import React from 'react'
import { SettingsWrapper } from '../components/common'
import { CompanyRuleSettings } from '../components/CompanyRuleSettings'

export const CompanyRulesSettings: React.FC = () => (
  <SettingsWrapper grid={{ flow: 'row' }}>
    <CompanyRuleSettings />
  </SettingsWrapper>
)
